import React from 'react';
import _ from 'lodash';

import { VehicleIcon } from './VehicleIcon';
import { OrderId } from './OrderId';
import { ftime } from '../../../utils/date';
import { DeliveryStatus } from './DeliveryStatus';
import { DriverName } from './DriverName';
import { DeliveryBag } from './DeliveryBag';

import './orderIcons';
import './Order.scss';

export class HistoryOrder extends React.Component {
    render() {
        const order = this.props.order;

        const driver = _.find(this.props.drivers, { id: order.driverId });
        const from = order.createdBy;
        return (
            <div className="sidebar-order">
                <div>
                    <div className="media-left">
                        <img src="./side_list.svg" />
                    </div>
                    <div className="media-body">
                        <span>Order: </span>
                        <OrderId order={order} />
                        &nbsp;
                        <div className="float-right">
                            <img src="./side_list_arrow.svg" />
                        </div>
                        <VehicleIcon order={order} />
                    </div>
                </div>
                <div>
                    <span>Submitted: </span>
                    <span className="float-right">
                        {from && from.name}
                    </span>
                </div>
                <div>
                    <span>Driver: </span>
                    <DriverName driver={driver} className="float-right"/>
                </div>
                <div>
                    <img src="./side_watch.svg" />
                    <span>Time: </span>
                    <img src="./side_pickup.svg" />
                    <span>{ftime(order.expectedPickUpTime.startTime)}</span>
                    -
                    <span>{ftime(order.expectedPickUpTime.endTime)}</span>
                    <img src="./side_delivery.svg" />
                    <span>{ftime(order.deliveryTime)}</span>
                </div>
                <div>
                    <span>Status: </span>
                    <DeliveryStatus className="float-right" order={order} />
                </div>
                <div>
                    <div className="media-left">
                        <span>Items: </span>
                    </div>
                    <div className="media-body">
                        <DeliveryBag order={order} className="float-right" />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/HistoryOrder.js